import { render } from "./XFollowers.vue?vue&type=template&id=0b7d65fe&scoped=true&ts=true"
import script from "./XFollowers.vue?vue&type=script&lang=ts"
export * from "./XFollowers.vue?vue&type=script&lang=ts"

import "./XFollowers.vue?vue&type=style&index=0&id=0b7d65fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7d65fe"]])

export default __exports__